module.exports = __webpack_public_path__ + "static/media/gadzety_kreatywne_03_B.b94e3b3e.png";